<template>
<div v-if="asignacion_items">
    <Box  @close="close(false)">
        <template #top>Asignación N° {{ ait_id }}</template>
        <template #center>
            <div class="nj-panel">
                <div class="nj-panel-content">
                    <div class="nj-subtitle-1">Datos</div>
                    <div class="nj-grid">
                        <LabelGroup label="Solicitante" :value="asignacion_items.emp_solicitante_nombre"></LabelGroup>
                        <LabelGroup label="Autorizador" :value="asignacion_items.emp_autorizador_nombre"></LabelGroup>
                        <LabelGroup label="Registrado por" :value="asignacion_items.usu_registrador_nombre"></LabelGroup>
                        <LabelGroup label="Fecha de asignación" :value="asignacion_items.ait_fecha_registro"></LabelGroup>
                    </div>
                    <br>
                    <div class="nj-subtitle-1">Items</div>
                    <b-table :data="asignacion_items.lista_asignacion_items_detalle">
                        <template slot-scope="props">
                            <b-table-column label="ID" header-class="is-info">{{ props.row.pal_id }}</b-table-column>
                            <b-table-column label="Producto" header-class="is-info">{{ props.row.prv_nombre }}</b-table-column>
                            <b-table-column label="Cantidad asignada" header-class="is-info">{{ props.row.aid_cantidad }}</b-table-column>
                            <b-table-column label="Cantidad devuelta" header-class="is-info">{{ props.row.did_cantidad_total }}</b-table-column>
                            <b-table-column label="Saldo" header-class="is-info">{{ props.row.aid_saldo }}</b-table-column>
                            <b-table-column label="Observaciones" header-class="is-info">{{ props.row.aid_notas }}</b-table-column>
                        </template>
                    </b-table>
                </div>
            </div>
        </template>
    </Box>
</div>
</template>

<script>
import { Box, LabelGroup } from "../components"
import Toast from "../../util/toast"
import { AsignacionItemsService, ResponseStatus } from "../../rest"

export default {
    name: "VerAsignacionItems",
    props: {
        ait_id: {
            type: Number
        }
    },
    components: {
        LabelGroup,
        Box,
    },
    data() {
        return {
            asignacion_items: null
        }
    },
    methods: {
        obtener() {
            AsignacionItemsService
                .obtener({
                    asignacion_items: {
                        ait_id: this.ait_id
                    }
                })
                .then(response => {
                    this.asignacion_items = response.data
                })
                .catch(error => {
                    Toast.error(error)
                    
                })
        },
        close() {
            this.$emit("close", false)
        },
    },
    mounted() {
        this.obtener()
    }
}
</script>

<style scoped></style>